import React from 'react'
import { Typography, Card, CardContent } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import * as R from 'ramda'
import clsx from 'clsx'
import { TruncatedTextWithTooltip } from 'app/components/TruncatedTextWithTooltip'
import { formatHomelessGroup } from 'commons/groupLogic'
import { isEmptyOrNil } from 'libs/empty'
import { EmptyText } from 'app/components/empty/EmptyContent'

export default (props) => {
  const { classes, state } = props
  const { formatMessage } = useIntl()
  var languages = new Set()
  const limitSizeGroupName = 30

  state.groupDetailsList.tags &&
    state.groupDetailsList.tags.forEach((elem) => {
      if (elem.subscribers && elem.subscribers.length > 0) {
        elem.subscribers.forEach((subscriber) => {
          if (subscriber['parent']) {
            const language =
              subscriber['parent'] && subscriber['parent']['language']
            if (language) {
              languages.add(language['languageDetails']['name'])
            }
          }
        })
      }
    })

  let lang = []
  languages.forEach((item, key) => {
    lang.push(<Typography key={key}>{item}</Typography>)
  })

  return (
    <div className="flex-1 h-0 overflow-y-auto">
      <Card className={clsx(classes.card, classes.languageCard, 'm-0')}>
        <CardContent className="flex flex-col">
          <TruncatedTextWithTooltip
            text={formatMessage(
              { id: 'groups.languages.title' },
              {
                groupName: R.compose(
                  R.ifElse(
                    isEmptyOrNil,
                    R.always(''),
                    R.compose(
                      R.prop('name'),
                      formatHomelessGroup(formatMessage),
                    ),
                  ),
                  R.prop('groupDetailsList'),
                )(state),
                langCount: R.length(lang),
              },
            )}
            limitSize={limitSizeGroupName}
            typographyProps={{
              className: clsx(classes.groupsLanguagesTitle, 'pb-3'),
            }}
          />
          <div className={clsx(classes.langItem, 'flex-1')}>
            {R.ifElse(
              R.isEmpty,
              () => (
                <EmptyText
                  variant="body2"
                  descriptionLabel={
                    <FormattedMessage id="subscriber.language.empty.label" />
                  }
                />
              ),
              (lang) => <div>{lang}</div>,
            )(lang)}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
